import posthog from "posthog-js";
import * as Sentry from "@sentry/react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { isMyAppWKWebView } from "./isMyAppWKWebView";

export async function getUserCustomToken() {
  const startTime = performance.now();

  if (window.Android) {
    if (!window._androidPromise) {
      window._androidPromise = {};
    }

    const promiseId = window.crypto.randomUUID();
    const returnPromise = new Promise<string>((resolve, reject) => {
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      window._androidPromise![promiseId] = { resolve, reject };
    });

    window.Android.getUserCustomToken(promiseId);

    return returnPromise.finally(() => {
      const endTime = performance.now();
      posthog.capture("getUserCustomToken_return", {
        duration: endTime - startTime,
      });
    });
  }

  if (isMyAppWKWebView()) {
    const returnPromise =
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      (window.webkit as any).messageHandlers.getUserCustomToken.postMessage(undefined);

    return returnPromise.finally(() => {
      const endTime = performance.now();
      posthog.capture("getUserCustomToken_return", {
        duration: endTime - startTime,
      });
    });
  }

  // Add web implementation as fallback
  return getWebUserCustomToken().finally(() => {
    const endTime = performance.now();
    posthog.capture("getUserCustomToken_return", {
      duration: endTime - startTime,
    });
  });
}

async function getWebUserCustomToken() {
  try {
    // Get the current user from Firebase Auth
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      return null;
      // throw new Error("User is not logged in");
    }
    
    // If you're using PostHog, identify the user
    posthog.identify(currentUser.uid);
    
    // Call Firebase function to get custom token
    const functions = getFunctions();
    
    // The key change is here - your cloud function doesn't expect any parameters
    const getUserCustomTokenFn = httpsCallable(functions, "getUserCustomToken");
    const result = await getUserCustomTokenFn();
    
    // Extract the token from the result
    // Cloud functions return data in the data property
    const userCustomToken = result.data as string;
    
    if (typeof userCustomToken !== 'string') {
      throw new Error("User custom token is nil");
    }
    
    return userCustomToken;
    
  } catch (error) {    
    if (Sentry) {
      Sentry.captureException(error);
    }
    
    throw error;
  }
}